import React from 'react';
import DatePicker from 'react-datepicker';

type DateChangedHandler = (date: Date) => void;

export type DatesProps = {
	selectedDate?: Date,
	dateChanged: DateChangedHandler
}

export const DateSelector = (props: DatesProps) => {

	const onDateChange = (date: Date, event: React.SyntheticEvent<any, Event>) => {
		props.dateChanged(date);
	}

	return (
		<DatePicker
			onChange={onDateChange}
			selected={props.selectedDate}
		/>
	);
}